<template>
  <div>
    <!-- 批量导入 -->
    <el-dialog
      :title="title"
      :visible.sync="showType"
      :before-close="cancelAction"
      width="820px"
    >
      <div class="import-body">
        <div style="height: 'auto'">
          <div class="importBtns">
            <el-upload
              ref="upload"
              class="upload-file"
              accept=".xlsx"
              :limit="1"
              action="#"
              :file-list="fileList"
              :on-remove="handleRemove"
              :on-exceed="handleExceed"
              :on-change="handleChangeList"
              :http-request="
                (ctx) => {
                  handleChange(ctx)
                }
              "
            >
              <el-button
                slot="trigger"
                type="primary"
                :loading="uploadFileLoading"
              >
                上传
              </el-button>
            </el-upload>

            <div class="button-right">
              <el-button
                style="margin-left: 10px"
                type="success"
                class="m-r-6"
                :loading="haddleFileLoading"
                @click="haddleFile"
              >
                导入
              </el-button>
              <el-button
                type="text"
                @click="downloadTemplate"
              >
                下载文件模板
              </el-button>
              <el-button
                v-if="isShowDownload === 'true'"
                type="text"
                @click="exportData"
              >
                导出导购数据
              </el-button>
            </div>
          </div>
        </div>

        <!-- 商品佣金设置 -->
        <div class="import-tips">
          <slot />
        </div>
      </div>
    </el-dialog>
    <el-dialog
      title="导出导购数据"
      :visible.sync="showExport"
      :before-close="cancelExport"
      width="820px"
    >
      <el-form
        ref="form"
        :model="form"
        label-width="80px"
      >
        <el-form-item>
          <el-radio-group v-model="form.resource">
            <el-radio label="未绑定门店导购" />
            <el-radio label="按门店导出" />
            <el-radio label="全量" />
          </el-radio-group>
        </el-form-item>
        <el-form-item v-if="form.resource === '按门店导出'">
          <!-- <SpSearchStore @chooseStore="chooseStore" /> -->
          <div>
            <el-input
              v-model="storeNum"
              placeholder="请选择店铺"
              :disabled="true"
              style="width: 300px"
            >
              <div slot="append">
                <el-link
                  type="primary"
                  style="margin-right: 10px"
                  @click="salesOrganizationVisible = true"
                >
                  选择店铺
                </el-link>
                <!-- <el-link type="primary" @click="clearStore"> 重置 </el-link> -->
              </div>
            </el-input>

            <SpSalesOrganization
              v-model="salesOrganizationVisible"
              :show-store="showStore"
              :show-group="showGroup"
              :select-data="salesData"
              :choose-only-store="chooseOnlyStore"
              :is-show-select-group="isShowSelectGroup"
              @saveBindOrganization="saveBindOrganization"
            />
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button
          type="primary"
          @click="handleConfirmExport"
        >导出</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { downloadTemplate, uploadFile, haddleFile } from '@/api/file'
export default {
  name: 'SpBulkImport',
  model: {
    prop: 'showType',
    event: 'showTypeChange'
  },
  props: {
    showType: {
      type: Boolean,
      default: false
    },
    title: {
      // 标题
      type: String,
      default: ''
    },
    fileType: {
      // 模板类型
      type: String,
      default: ''
    },
    addParams: {
      type: Object
    },
    isShowDownload: {
      type: String,
      default: 'false'
    }
  },
  data () {
    return {
      fileList: [],
      uploadFileId: 0,
      uploadFileLoading: false,
      haddleFileLoading: false,
      showExport: false,
      form: {
        resource: '',
        store_id: ''
      },
      storeNum: null,
      salesOrganizationVisible: false,
      showStore: true,
      showGroup: false,
      chooseOnlyStore: true,
      isShowSelectGroup: true,
      salesData: {
        selectedStoreIds: [],
        selectedGroupsIds: []
      }
    }
  },
  watch: {
    showType (newVal, oldVal) {
      if (newVal) {
        this.fileList = []
        this.uploadFileId = 0
        this.haddleFileLoading = false
      }
    }
  },
  methods: {
    // 超出文件数量提示
    handleExceed () {
      this.$message.error('请先删除选择的文件，再上传')
    },
    // 移除文件替换
    handleRemove (res, file) {
      this.fileList = file
    },
    // 变更文件替换
    handleChangeList (file, fileList) {
      this.fileList = fileList
    },

    // 下载文件模板
    async downloadTemplate () {
      const data = await downloadTemplate({
        file_type: this.fileType
      })
      if (data) {
        const a = document.createElement('a')
        a.href = data.url
        a.download = data.file_name
        a.click()
      }
    },

    // 上传到服务器
    async handleChange (ctx) {
      this.uploadFileLoading = true
      let { file } = ctx
      let params = new FormData()
      params.append('file_type', this.fileType)
      params.append('file', file)
      const data = await uploadFile(params).catch((v) => {
        this.fileList = []
        this.uploadFileLoading = false
      })
      if (data) {
        this.uploadFileId = data.id
        this.uploadFileLoading = false
        this.$message({
          message: '上传成功',
          type: 'success'
        })
      }
    },
    // 导入文件
    async haddleFile () {
      if (!this.uploadFileId || this.fileList.length <= 0) {
        return this.$message.error('请先上传文件再导入')
      }
      this.haddleFileLoading = true
      let params = {
        file_type: this.fileType
      }
      if (this.addParams) {
        params = Object.assign({}, params, this.addParams)
      }
      const data = await haddleFile(this.uploadFileId, params).catch((v) => {
        this.haddleFileLoading = false
      })
      if (data) {
        this.$message({
          message: '导入成功',
          type: 'success'
        })
        this.haddleFileLoading = false
        this.$emit('showTypeChange', false)
        this.$emit('saveImportAction')
      }
    },

    // 关闭模态框
    cancelAction () {
      this.fileList = []
      this.$emit('showTypeChange', false)
    },
    exportData () {
      this.showExport = true
    },
    cancelExport () {
      this.showExport = false
    },
    async handleConfirmExport () {
      const params = {}
      if (this.form.resource === '未绑定门店导购') {
        params.store_id = 0
      }
      if (this.form.resource === '按门店导出') {
        if (this.form.store_id.length === 0) {
          return this.$message.error('请选择店铺')
        } else {
          params.store_id = this.form.store_id[0]
        }
      }
      if (this.form.resource === '全量') {
        params.store_id = -1
      }
      const data = await this.$api.file.createExportList(params, 23).catch(() => {
        // this.createLoading = false
      })
      if (data && data.download_data) {
        // this.createLoading = false
        const a = document.createElement('a')
        a.href = data.download_data.url
        a.download = data.download_data.file_name
        a.click()
      } else if (data && !data.download_data) {
        this.$message({
          message: '请求成功，异步处理中，请稍后到 导出列表 进行下载！',
          type: 'success'
        })
      }
    },
    saveBindOrganization (selectData) {
      this.form.store_id = selectData
      this.storeNum = '已选择' + selectData.length + '家门店'
      this.salesOrganizationVisible = false
    }
  }
}
</script>

<style lang="scss" scoped>
.import-body {
  margin-top: -20px;
  .import-content {
    height: auto;
    margin-bottom: 25px;
  }
  .importBtns {
    height: auto;
    position: relative;
  }
  .button-right {
    display: flex;
    align-items: center;
    position: absolute;
    left: 84px;
    top: 0;
    margin: auto;
  }

  .import-tips {
    color: #999999;
    font-size: 12px;
    line-height: 24px;
    margin-top: 25px;
  }
}
</style>
